export const ExternalUrlService = {
  getTofuNftAkiverseGCPage: () => 'https://tofunft.com/collection/akiverse-game-centers/items',
  getTofuNftAkiverseAMPage: () => 'https://tofunft.com/collection/akiverse-arcade-machines/items',
  getTofuNftAkiverseAPPage: () => 'https://tofunft.com/collection/akiverse-arcade-parts/items',
  getStakingUrl: () => '/staking',
  getAkvLink: () =>
    `https://quickswap.exchange/#/swap?outputCurrency=${process.env.NEXT_PUBLIC_AKV_CONTRACT_ADDRESS}`, // TODO: AKVが取得できるぺー時,
  getDiscordLink: () => 'https://discord.gg/xEkgQnU7Za',
  getSupportCenterLink: () => 'https://support.akiverse.io/',
  getPfpOfficialSite: () => 'https://pfp.akiverse.io/',
}
